import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";

type NoDataCellProps = Omit<GridCustomCellProps, "dataItem"> & {
	value: string | number | null | undefined;
};

export const NoDataCell = (props: NoDataCellProps) => {
	return (
		<GridTd tdProps={props.tdProps}>
			{props.value?.toString().length ? props.value : "N/A"}
		</GridTd>
	);
};
